import type { QuizCategory } from '@efdigital/ll-addon-data';
import { textColorStyle } from '@efdigital/ll-admin-v2/lib/color';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    category: string;
    categories: QuizCategory[];
  };
}

export class CategoryIcon extends Component<Signature> {
  get category(): QuizCategory | undefined {
    return this.args.categories.find((c) => c.cid === this.args.category);
  }

  get colour(): string {
    return this.category?.colour || '#000000';
  }

  <template>
    {{#if this.category}}
      <iconify-icon icon="ph:sigma-fill" style={{textColorStyle this.colour}} />
    {{else}}
      <iconify-icon icon="ph:sigma" />
    {{/if}}
  </template>
}
